import { lazy, type ComponentType } from 'react';

/**
 * Comme React.lazy, mais si le chunk échoue à se charger (typiquement après un
 * nouveau déploiement où les noms de fichiers hashés ont changé, ou un asset
 * temporairement indisponible), on force UNE seule rechargement complet de la
 * page pour récupérer un index.html frais pointant vers les bons chunks.
 * Évite l'erreur fatale « error loading dynamically imported module ».
 */
const RELOAD_KEY = 'proxy_chunk_reload';

export function lazyWithRetry<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>
) {
  return lazy(async () => {
    try {
      const mod = await factory();
      // Chargement OK → on réautorise un futur reload pour le prochain déploiement
      try { window.sessionStorage.removeItem(RELOAD_KEY); } catch { /* ignore */ }
      return mod;
    } catch (err) {
      try {
        if (typeof window !== 'undefined' && !window.sessionStorage.getItem(RELOAD_KEY)) {
          window.sessionStorage.setItem(RELOAD_KEY, '1');
          window.location.reload();
          // On suspend jusqu'au rechargement (pas de rendu d'erreur visible)
          return await new Promise<{ default: T }>(() => {});
        }
      } catch { /* ignore */ }
      throw err;
    }
  });
}
